import React from 'react';
import CollectionPage from '../../collection_page/components/CollectionPage';

const CollectionPageClient = (props) => <CollectionPage {...props} />;

export default CollectionPageClient;
